import { Controller } from "@hotwired/stimulus"

import { formatPrice } from "@/helpers/price_format"
import { pluralize } from "@/helpers/pluralize"

import TooltipController from "./tooltip_controller"

export default class extends Controller<HTMLElement> {
  static outlets = ["tooltip"]
  declare readonly tooltipOutlet: TooltipController

  static targets = [
    "guests",
    "klarnaPrice",
    "paxRadio",
    "productList",
    "productRadio",
    "productType",
    "totalPrice"
  ]
  declare readonly guestsTarget: HTMLElement
  declare readonly klarnaPriceTargets: HTMLElement[]
  declare readonly paxRadioTargets: HTMLInputElement[]
  declare readonly productListTargets: HTMLElement[]
  declare readonly productRadioTargets: HTMLInputElement[]
  declare readonly productTypeTarget: HTMLElement
  declare readonly totalPriceTargets: HTMLElement[]

  // TODO: Remove during cleanup of the improved_package_page_variant experiment.
  declare readonly hasKlarnaPriceTarget: boolean
  declare readonly hasTooltipOutlet: boolean

  connect(): void {
    this.updateTotalPrice()
  }

  selectOccupancy(): void {
    this.toggleProductList()
    const currentSelectedProduct = this.selectedProductRadio.value

    const productRadiosForSelectedPax = this.productRadioTargets.filter(
      this.matchesSelectedPax.bind(this)
    )
    const productToSelect =
      productRadiosForSelectedPax.find((radio) => radio.value === currentSelectedProduct) ||
      productRadiosForSelectedPax[0]

    productToSelect.checked = true

    this.guestsTarget.textContent = pluralize(parseInt(this.selectedPax), "guest")
    this.updateTooltipMessage()
    this.updateTotalPrice()
  }

  selectProduct(): void {
    this.updateTotalPrice()
    this.updateTooltipMessage()
    this.productTypeTarget.textContent = this.selectedProductRadio.dataset.label!
  }

  updateTotalPrice(): void {
    const totalPrice = parseFloat(this.selectedProductRadio.dataset.price!)

    this.totalPriceTargets.forEach((target) => {
      target.textContent = formatPrice(totalPrice)
    })

    if (this.hasKlarnaPriceTarget) {
      const klarnaPrice = formatPrice(totalPrice / 3)

      this.klarnaPriceTargets.forEach((target) => {
        target.textContent = klarnaPrice
      })
    }
  }

  private toggleProductList(): void {
    this.productListTargets.forEach((list) => {
      list.hidden = !this.matchesSelectedPax(list)
    })
  }

  private matchesSelectedPax(element: HTMLElement): boolean {
    return element.dataset.occupancy! === this.selectedPax
  }

  private updateTooltipMessage(): void {
    if (this.hasTooltipOutlet) {
      this.tooltipOutlet.messageValue = `For ${pluralize(parseInt(this.selectedPax), "guest")} - ${this.selectedProductRadio.dataset.label!}`
    }
  }

  private get selectedPax(): string {
    return this.paxRadioTargets.find((radio) => radio.checked)!.value
  }

  private get selectedProductRadio(): HTMLInputElement {
    return this.productRadioTargets.find((product) => product.checked)!
  }
}
